import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AvatarModule } from '@jms/ui/ui.avatar';
import { FieldModule } from '@jms/ui/ui.field';
import { NgSelectModule } from '@ng-select/ng-select';
import { CompanyPickerComponent, PickerItemComponent, LabelPickerComponent, ZonePickerComponent, StatePickerComponent, SecurityRolePickerComponent } from './components';
import { ContactPickerModule } from '@jms/ui/ui.pickers.contact';

const pickers = [
    CompanyPickerComponent,
    PickerItemComponent,
    LabelPickerComponent,
    ZonePickerComponent,
    StatePickerComponent,
    SecurityRolePickerComponent
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AvatarModule,
        NgSelectModule,
        FieldModule,
        ContactPickerModule
    ],
    declarations: [...pickers],
    exports: [...pickers, ReactiveFormsModule],
    providers: [],
})
export class CorePickersModule {

}
